export const formFocus = () => {
  // --------- helpers ----------
  const getControl = (field) => field.querySelector("input, textarea, select");

  const setActiveState = (field) => {
    const control = getControl(field);
    if (!control) return;
    if (control.value && control.value.trim()) field.classList.add("cf7-form__field--active");
    else field.classList.remove("cf7-form__field--active");
  };

  const setInvalidState = (field) => {
    const control = getControl(field);
    if (!control) return;

    if (control.classList.contains("wpcf7-not-valid")) {
      field.classList.add("cf7-form__field--invalid");
    } else {
      field.classList.remove("cf7-form__field--invalid");
    }
  };

  const syncFieldState = (field) => {
    setActiveState(field);
    setInvalidState(field);
  };

  // --------- 1) focus/active + invalid per field ----------
  const fields = document.querySelectorAll(".cf7-form__field");
  if (fields.length) {
    fields.forEach((field) => {
      const control = getControl(field);
      if (!control) return;

      // initial (np. autofill)
      syncFieldState(field);

      control.addEventListener("focus", () => {
        field.classList.add("cf7-form__field--active");
      });

      control.addEventListener("blur", () => {
        // active tylko jeśli coś wpisane
        setActiveState(field);
        // invalid może się zmienić po blur/change
        setInvalidState(field);
      });

      // live update (wpisywanie / zmiany)
      control.addEventListener("input", () => syncFieldState(field));
      control.addEventListener("change", () => syncFieldState(field));
    });
  }

  // --------- 2) move not-valid tips as siblings of .cf7-form__field ----------
  const forms = document.querySelectorAll(".wpcf7 form");
  if (!forms.length) return;

  const moveTip = (tipEl) => {
    if (!tipEl || !tipEl.classList || !tipEl.classList.contains("wpcf7-not-valid-tip")) return;

    const field = tipEl.closest(".cf7-form__field");
    if (!field) return;

    // already placed directly after field
    if (field.nextElementSibling === tipEl) return;

    // remove duplicates already next to field (keep current one)
    let sib = field.nextElementSibling;
    while (sib && sib.classList.contains("wpcf7-not-valid-tip")) {
      const toRemove = sib;
      sib = sib.nextElementSibling;
      if (toRemove !== tipEl) toRemove.remove();
    }

    field.after(tipEl);
  };

  const moveAllTipsIn = (root) => {
    root.querySelectorAll(".wpcf7-not-valid-tip").forEach(moveTip);
  };

  const syncAllFieldsIn = (root) => {
    root.querySelectorAll(".cf7-form__field").forEach(syncFieldState);
  };

  // CF7 lifecycle events (submit invalid / spam / mail failed / etc.)
  document.addEventListener("wpcf7invalid", (e) => {
    moveAllTipsIn(e.target);
    syncAllFieldsIn(e.target);
  });

  document.addEventListener("wpcf7spam", (e) => {
    moveAllTipsIn(e.target);
    syncAllFieldsIn(e.target);
  });

  document.addEventListener("wpcf7mailfailed", (e) => {
    moveAllTipsIn(e.target);
    syncAllFieldsIn(e.target);
  });

  // optional: clean states after success/reset
  document.addEventListener("wpcf7mailsent", (e) => {
    const root = e.target;
    root.querySelectorAll(".cf7-form__field").forEach((field) => {
      field.classList.remove("cf7-form__field--invalid");
      setActiveState(field); // zostawi active jeśli coś jest, zwykle będzie pusto
    });
  });

  // --------- 3) MutationObserver to catch live validation changes ----------
  forms.forEach((form) => {
    // initial
    moveAllTipsIn(form);
    syncAllFieldsIn(form);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        // tips added anywhere
        if (m.type === "childList") {
          m.addedNodes?.forEach((node) => {
            if (node.nodeType !== 1) return;

            if (node.classList?.contains("wpcf7-not-valid-tip")) {
              moveTip(node);
            } else {
              node.querySelectorAll?.(".wpcf7-not-valid-tip")?.forEach(moveTip);
            }
          });

          // CF7 czasem miesza DOM bez oczywistych zmian — bezpieczny rescan
          moveAllTipsIn(form);
          syncAllFieldsIn(form);
        }

        // class changes (wpcf7-not-valid toggles)
        if (m.type === "attributes" && m.attributeName === "class") {
          const el = m.target;
          if (el && el.classList && el.classList.contains("wpcf7-form-control")) {
            const field = el.closest(".cf7-form__field");
            if (field) syncFieldState(field);
          }
        }
      }
    });

    observer.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  });
};